/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
  body.classList.add("is-touch-device");
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

Fancybox.bind(".fancybox-storyboard", {
  closeButton: false,
  infinite: true,
  on: {
    done: (fancybox, slide) => {
      const slideContent = slide.$container || document;
      const closeButtons = slideContent.querySelectorAll(".popup__close");

      closeButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          Fancybox.close();
        });
      });
    }
  }
});

/*  ==========================================================================
    GENERAL - Topics expand all for post tiles 
  ========================================================================== */

const topicsToggleInit = function () {
  const toggles = document.querySelectorAll(".topics__toggle");
  if (toggles.length) {
    toggles.forEach(function (toggle) {
      if (toggle.getAttribute("data-topics-init") === "true") {
        return;
      }
      toggle.setAttribute("data-topics-init", "true");

      toggle.addEventListener("click", function () {
        const wrapId = toggle.getAttribute("data-target");
        const wrap = document.getElementById(wrapId);
        if (!wrap) {
          return;
        }
        const more = wrap.querySelector(".topics__more");
        if (!more) {
          return;
        }
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        // toggle visibility
        if (expanded) {
          more.hidden = true;
          more.setAttribute("aria-hidden", "true");
          toggle.setAttribute("aria-expanded", "false");
          toggle.textContent = toggle.getAttribute("data-hide-text"); // "+N more"
        } else {
          more.hidden = false;
          more.setAttribute("aria-hidden", "false");
          toggle.setAttribute("aria-expanded", "true");
          toggle.textContent = toggle.getAttribute("data-show-text"); // "Show less"
        }
      });
    });
  }
}; // topicsToggleInit();

topicsToggleInit();

/*  ==========================================================================
    GENERAL - Copy email address 
  ========================================================================== */

const emailCopyInit = function () {
  const tags = document.querySelectorAll(".tag--email");

  if (tags.length) {
    tags.forEach(function (tag) {
      tag.addEventListener("click", function () {
        const email = tag.getAttribute("data-email");
        if (!email) {
          return;
        }

        const originalText = tag.textContent;

        navigator.clipboard.writeText(email).then(function () {
          tag.textContent = "Copied";

          setTimeout(function () {
            tag.textContent = originalText;
          }, 2000);
        });
      });
    });
  }
}; // emailCopyInit();

emailCopyInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      topicsToggleInit();
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        topicsToggleInit();
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum =
      parseInt(currentPageNum) > parseInt(php_variables.max_page) ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const logosMarquees = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const logosMarqueeinit = function () {
  if (logosMarquees.length <= 0) {
    return;
  }

  logosMarquees.forEach(elem => {
    window.addEventListener("resize", function () {
      marquee__resize(elem);
    });

    // Repeating Logos and Text to make sure it fills the width of the view port
    const viewportWidth = window.innerWidth;
    const minWidth = (viewportWidth * 1) / 2;

    const tiles = elem.querySelectorAll(".marquee__tile");
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;

    // Wrapping the tiles
    elem.innerHTML = "<div class='" + innerClass + "'>" + elem.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = elem.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = elem.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    elem.appendChild(repeatingTextClone);
    elem.appendChild(repeatingTextClone2);

    // Setup animation times
    marquee__resize(elem);

    // Once everything is set up, add "loaded" class
    elem.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", logosMarqueeinit);

/*  ==========================================================================
    ANIMATION - Pinned Content
    ========================================================================== */

const pinnedContentModules = document.querySelectorAll(".module--pinned-content");

const pinnedModuleInit = function (pinnedContentModules) {
  if (!pinnedContentModules || pinnedContentModules.length <= 0) {
    return;
  }

  pinnedContentModules.forEach(function (pinnedContent) {
    const stickyCol = pinnedContent.querySelector(".col--sticky");
    const mediaColumnPinTop = pinnedContent.querySelector(".mediacolumpintop");
    const mediaColumnPinBottom = pinnedContent.querySelector(".mediacolumpinbottom");
    const textColumnPin = pinnedContent.querySelector(".textcolumpin");
    const blockCta = pinnedContent.querySelector(".blockcta__wrap");
    const pinnedMedia = pinnedContent.querySelector(".pinned-content__media"); // Single element
    const pinnedTextItems = pinnedContent.querySelectorAll(".pinned-content__item");

    if (!pinnedMedia || pinnedTextItems.length === 0) {
      return;
    }

    if (blockCta) {
      let topInView = false;
      let bottomInView = false;
      const mediaColumnObserverTop = new IntersectionObserver(
        (entries, observer) => {
          // Only interested in the firts entry
          if (entries[0].isIntersecting) {
            topInView = true;
          } else {
            topInView = false;
          }
        },
        { threshold: 1 }
      );

      mediaColumnObserverTop.observe(mediaColumnPinTop);

      //Observer for the text colum
      const mediaColumnObserverBottom = new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].isIntersecting) {
            bottomInView = true;
          } else {
            bottomInView = false;
          }

          // Only interested in the firts entry

          if (entries[0].isIntersecting && topInView) {
            blockCta.classList.add("fixed");
          } else if (entries[0].isIntersecting) {
            blockCta.classList.remove("fixed");
          } else {
            blockCta.classList.remove("fixed");
          }
        },
        { threshold: 1 }
      );

      mediaColumnObserverBottom.observe(mediaColumnPinBottom);

      //Observer for the text colum
      const textColumnObserver = new IntersectionObserver(
        (entries, observer) => {
          // Only interested in the firts entry
          if (entries[0].isIntersecting) {
            blockCta.classList.remove("fixed");
            blockCta.classList.add("fixedbottom");
          } else {
            // is not intersecting
            if (bottomInView) {
              blockCta.classList.add("fixed");
              blockCta.classList.remove("fixedbottom");
            }
          }
        },
        { threshold: 1 }
      );

      textColumnObserver.observe(textColumnPin);
    }

    const options = {
      threshold: 0.5
    };

    const pinnedItemsObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Remove all active classes
          let mediaItems = pinnedContent.querySelectorAll(".media__item");
          for (let i = 0; i < mediaItems.length; i++) {
            mediaItems[i].classList.remove("active");
          }

          let mediaClass = entry.target.dataset.media;
          if (mediaClass) {
            let targetImage = pinnedContent.querySelector("." + mediaClass);
            if (targetImage) {
              targetImage.classList.add("active");
            }
          }
        }
      });
    }, options);

    pinnedTextItems.forEach(item => {
      pinnedItemsObserver.observe(item);
    });
  });
};

pinnedModuleInit(pinnedContentModules);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const customNav = elem.dataset.customnav ? elem.dataset.customnav : false;

    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    if (customNav) {
      // Vanilla wiring for buttons
      const elemModule = elem.closest(".module");
      const prevBtn = elemModule.querySelector(".btn--prev");
      const nextBtn = elemModule.querySelector(".btn--next");

      console.log(prevBtn, nextBtn);

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener("click", () => {
          console.log("prev");
          owlCarousel.trigger("prev.owl.carousel"); // Owl requires jQuery trigger
        });

        nextBtn.addEventListener("click", () => {
          owlCarousel.trigger("next.owl.carousel");
        });

        // Scoped sync for this instance
        const syncButtons = event => {
          //  Get data from owl carousel so that state of buttons works responsively with different item counts
          var api = event && event.relatedTarget ? event.relatedTarget : owlCarousel.data("owl.carousel");

          // Guard
          if (!api) {
            return;
          }

          // Pass api to computeNavState function to check which buttons to enable/disable
          var state = computeNavState(api);

          // If loop is true, you are never at "ends"; leave both enabled
          var loop = !!(api.settings && api.settings.loop);

          if (prevBtn) {
            prevBtn.disabled = !loop && state.index <= 0;
          }
          if (nextBtn) {
            nextBtn.disabled = !loop && state.index >= state.last;
          }
        };

        owlCarousel.on("initialized.owl.carousel changed.owl.carousel", syncButtons);
        owlCarousel.trigger("refresh.owl.carousel");
      }
    }

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

// Sync Buttons function for Owl Carousel with custom nav buttons
function computeNavState(owlApi) {
  // owlApi is the Owl object (event.relatedTarget or $(el).data('owl.carousel'))
  if (!owlApi) {
    return { index: 0, last: 0 };
  }
  // current() returns absolute position (including clones when loop:true).
  // relative() converts it to the "real" index space.
  var index = owlApi.relative(owlApi.current());
  var last = owlApi.maximum(); // last valid position given current settings
  return { index: index, last: last };
}

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";
const mobnavDropdownPages = document.querySelectorAll(
  ".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdowntoggle"
);
const mobnavMain = document.querySelector(".mobnav__main");
const topbar = document.querySelector(".topbar");
const dropdownsectionBacks = document.querySelectorAll(".dropdownsection__back");

const mobnavInit = function () {
  // Open mobnav on click the toggle
  if (!mobnavToggle && !mobnav) {
    return;
  }

  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
      // Set the focus to the Mobile Nav
      let mobnavLinks = mobnav.querySelectorAll("a");
      if (mobnavLinks && mobnavLinks[0]) {
        mobnavLinks[0].focus();
      }
      mobnavToggle.setAttribute("aria-expanded", true);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);

      // Reset the focus to the toggle
      mobnavToggle.focus();
      mobnavToggle.setAttribute("aria-expanded", false);

      // Reset the dropdown pages
      document.querySelectorAll(".dropdownsection").forEach(function (dropdownsection) {
        dropdownsection.classList.remove("dropdownsection--open");
        mobnavMain.classList.remove("mobnav__main--hidden");
      });
    }
  });

  // On escape check if the mobile nav is open
  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      if (body.classList.contains(mobnavOpenclass)) {
        body.classList.remove(mobnavOpenclass);

        // Reset the focus to the toggle
        mobnavToggle.focus();

        mobnavToggle.setAttribute("aria-expanded", false);
      }
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdown pages
      ========================================================================== */

const mobnavPagesInit = function () {
  if (!mobnavDropdownPages) {
    return;
  }

  let lastFocusedElement = false;

  mobnavDropdownPages.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();

      const mobnavTargetSection = e.target.closest(".sitenav__item");
      let dropdownsection = mobnav.querySelector(".dropdownsection--" + mobnavTargetSection.dataset.dropdownsection);

      if (dropdownsection.classList.contains("dropdownsection--open")) {
        dropdownsection.classList.remove("dropdownsection--open");
        mobnavMain.classList.remove("mobnav__main--hidden");
      } else {
        dropdownsection.classList.add("dropdownsection--open");
        mobnavMain.classList.add("mobnav__main--hidden");
      }
    });
  });

  if (!mobnavDropdownPages) {
    return;
  }

  dropdownsectionBacks.forEach(function (backButton) {
    backButton.addEventListener("click", function (e) {
      e.preventDefault();
      const dropdownsection = e.target.closest(".dropdownsection");
      dropdownsection.classList.remove("dropdownsection--open");
      mobnavMain.classList.remove("mobnav__main--hidden");
    });
  });
  // mobnavPagesInit();

  /*  ========================================================================== 
      NAVIGATION - mobnav search slide (custom for search panel)
      ========================================================================== */

  const mobnavSearchToggle = document.querySelector(".mobnav__search__toggle");
  const mobnavSearchSection = document.querySelector(".dropdownsection--mobnav-search-slide");
  const mobnavMainPanel = document.querySelector(".mobnav__main");

  if (mobnavSearchToggle && mobnavSearchSection && mobnavMainPanel) {
    mobnavSearchToggle.addEventListener("click", function (e) {
      e.preventDefault();
      mobnavSearchSection.classList.add("dropdownsection--open");
      mobnavMainPanel.classList.add("mobnav__main--hidden");
      // Set focus to the search input
      const searchInput = mobnavSearchSection.querySelector("input[type='search']");
      if (searchInput) searchInput.focus();
    });

    // Back button inside the search slide
    const searchBackBtn = mobnavSearchSection.querySelector(".dropdownsection__back");
    if (searchBackBtn) {
      searchBackBtn.addEventListener("click", function (e) {
        e.preventDefault();
        mobnavSearchSection.classList.remove("dropdownsection--open");
        mobnavMainPanel.classList.remove("mobnav__main--hidden");
        // Return focus to the search trigger
        mobnavSearchToggle.focus();
      });
    }
  }
}; // mobnavPagesInit();
mobnavPagesInit();

/*  ==========================================================================
      NAVIGATION - mobnav accordion dropdowns
      ========================================================================== */

const mobnavDropdowns = document.querySelectorAll(".mobnav .topnav__item--hasdropdown .topnav__item__main");

const mobnavlinksInit = function () {
  if (!mobnavDropdowns) {
    return;
  }

  let lastFocusedElement = false;

  mobnavDropdowns.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".topnav__item");
      mobnavTargetSection.classList.toggle("topnav__item--open");

      // Setting the aria label for the dropdown
      let aria = mobnavLink.getAttribute("aria-expanded");

      if (aria === "true") {
        aria = "false";
      } else {
        aria = "true";
      }
      mobnavLink.setAttribute("aria-expanded", aria);
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
    NAVIGATION - topnav dropdown escaping
    ========================================================================== */

const topnavToggles = document.querySelectorAll(".topnav__item--hasdropdown .topnav__toggle");

function topnav__init() {
  if (!topnavToggles) {
    return;
  }

  // Adding the aria expanded attribute when on hover
  topnavToggles.forEach(function (topnavToggle) {
    topnavToggle.addEventListener("click", e => {
      let expanded = topnavToggle.getAttribute("aria-expanded");
      if (expanded === "false") {
        topnavToggle.setAttribute("aria-expanded", "true");
        topnavToggle.classList.add("active");
      } else {
        topnavToggle.setAttribute("aria-expanded", "false");
        topnavToggle.classList.remove("active");
      }
    });

    let topnavDropdown = topnavToggle.nextElementSibling;

    if (topnavDropdown && topnavDropdown.classList.contains("topnav__item__dropdown")) {
      topnavDropdown.addEventListener("keydown", function (event) {
        // Escaping the dropdown on tab navigation
        if (event.key === "Escape" && topnavDropdown.contains(document.activeElement)) {
          topnavToggle.setAttribute("aria-expanded", "false");
          topnavToggle.classList.remove("active");

          topnavToggle.focus();
        }

        let sectionLinks = topnavDropdown.getElementsByTagName("a");

        if (event.shiftKey && event.key === "Tab") {
          // And the first link is on focus return the focus to the toplevel item
          if (sectionLinks[0] === document.activeElement) {
            topnavToggle.setAttribute("aria-expanded", "false");
            topnavToggle.classList.remove("active");
          }
        } else if (event.key === "Tab") {
          if (sectionLinks[sectionLinks.length - 1] === document.activeElement) {
            topnavToggle.setAttribute("aria-expanded", "false");
            topnavToggle.classList.remove("active");
          }
        }
      });
    }
  });
}

topnav__init();

/*  ==========================================================================
    NAVIGATION - sitenav dropdowns
    ========================================================================== */
const siteheader = document.querySelector(".siteheader");
const sitenav = document.querySelector(".sitenav--desktop");
const sitenavitems = sitenav.querySelectorAll("li[data-dropdownsection]");
const sitenavitemsNoDropdown = sitenav.querySelectorAll("li:not([data-dropdownsection])");
const sitenavdropdown = document.querySelector(".sitenav__dropdown");
const sitenavdropdownsections = document.querySelectorAll(".dropdownsection");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "dropdownsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;
let currentTopLevelItem = false;
let nextTabItem = false;

// Check if isMobile, and only init if desktop or Ipad
if (!isMobile) {
  sitenav__init();
}

function sitenav__init() {
  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.querySelector(".sitenav__link").addEventListener("click", function (e) {
        e.preventDefault();

        if (!this.classList.contains(overclass)) {
          navopen = false;
          sitenavitem__over(sitenavitem);
        } else {
          sitenav__out();
        }
      });
    });
    document.addEventListener("pointerdown", function (e) {
      if (!navopen) return;

      const clickedInsideHeader = e.target.closest(".siteheader");

      if (!clickedInsideHeader) {
        sitenav__out(false);
      }
    });
  } else {
    document.querySelector(".search-toggle").addEventListener("mouseover", e => {
      sitenav__out(false);
    });

    // IF DESKTOP...
    sitenavitems.forEach((sitenavitem, index) => {
      sitenavitem.querySelector(".sitenav__link").addEventListener("mouseover", e => {
        sitenavitem__over(sitenavitem);
      });
      // sitenavitem.querySelector(".search-toggle").addEventListener("mouseover", e => {
      //   // sitenavitem__over(sitenavitem);
      //   console.log("close");
      // });

      // sitenavitem.querySelector(".sitenav__link").addEventListener("mouseout", e => {
      //   // sitenav__out();
      // });
      // Listening for focus on the sitenav item to open the dropdown
      sitenavitem.querySelector(".sitenav__link").addEventListener("focusin", e => {
        currentTopLevelItem = sitenavitem;
        currentTopLevelItem.querySelector(".sitenav__link").setAttribute("aria-expanded", true);

        if (index === document.querySelectorAll(".sitenav__link").length - 1) {
          //if it's the last item in the nav then the next item is the search toggle
          nextTabItem = document.querySelector(".search-toggle");
        } else {
          nextTabItem = currentTopLevelItem.nextElementSibling.querySelector(".sitenav__link");
        }

        sitenavitem__over(sitenavitem);
      });

      // Listing for keydown on the sitenavitem to take the user into the the dropdown
      sitenavitem.querySelector(".sitenav__link").addEventListener("keydown", function (event) {
        let dropdownsection = sitenavdropdown.querySelector(".dropdownsection--" + sitenavitem.dataset.dropdownsection);

        let sectionLinks = dropdownsection.getElementsByTagName("a");
        let firstSectionLink = sectionLinks[0];

        if (event.key === "Tab" && !event.shiftKey) {
          event.preventDefault();
          if (firstSectionLink) {
            firstSectionLink.focus();
          }
        }
      });
    });

    sitenavdropdownsections.forEach(function (dropdownsection) {
      dropdownsection.addEventListener("keydown", function (event) {
        let sectionLinks = dropdownsection.getElementsByTagName("a");

        if (event.shiftKey && event.key === "Tab") {
          // And the first link is on focus return the focus to the toplevel item
          if (sectionLinks[0] === document.activeElement) {
            event.preventDefault();
            currentTopLevelItem.querySelector(".sitenav__link").focus();
          }
        } else if (event.key === "Tab") {
          if (sectionLinks[sectionLinks.length - 1] === document.activeElement) {
            event.preventDefault();
            sitenav__out();
            if (nextTabItem) {
              nextTabItem.focus();
            }
          }
        }
      });
    });

    sitenavdropdown.addEventListener("mouseover", e => {
      dropdownsection__over();
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      sitenav__out();
    });

    sitenavdropdown.addEventListener("keydown", function (event) {
      // Escaping the dropdown on tab navigation
      if (
        event.key === "Escape" &&
        (sitenavdropdown.contains(document.activeElement) || currentTopLevelItem.contains(document.activeElement))
      ) {
        sitenav__out();
        if (nextTabItem) {
          nextTabItem.focus();
        }
      }
    });
    sitenavitemsNoDropdown.forEach((sitenavitem, index) => {
      const sitenavlink = sitenavitem.querySelector(".sitenav__link");
      if (!sitenavlink) return;

      sitenavlink.addEventListener("mouseenter", e => {
        sitenav__out(false);
      });
    });

    topbar.addEventListener("mouseover", e => {
      sitenav__out(false);
    });
  }
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  // On hover of sitenav item
  dropdownsection__open(sitenavitem);
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".dropdownsection--" + target_li.dataset.dropdownsection);
  var dropdown_height = target_section.offsetHeight;

  let sectionLinks = target_section.querySelectorAll("a");
  let firstSectionLink = sectionLinks[0];
  let firstTimein = true;

  if (!sitenavdropdown) return;

  // Make dropdown show and set classes to say it's open
  sitenavdropdown.style.visibility = "visible";
  sitenavdropdown.style.height = dropdown_height + "px";
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to stop dropdown closing
    window.clearTimeout(dropdownclosetimer);
  }
  // Remove over class from any old clicks
  if (document.querySelector("." + overclass)) {
    document.querySelector("." + overclass).classList.remove(overclass);
  }
  // close the search if open
  const searchNav = document.querySelector(".siteheader__search");
  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
  // add over class to current li
  target_li.classList.add(overclass);
  document.querySelector("body").classList.add(navopenbodyclass);
  if (document.querySelector("." + activesectionclass)) {
    document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
  }
  target_section.classList.add(activesectionclass);
} //dropdownsection__open();

function dropdownsection__over() {
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out(delay = true) {
  // On leave sitenav hover
  navopen = false;
  //Setting responsive attribute to false
  sitenavitems.forEach(function (sitenavitem) {
    let sitenavlink = sitenavitem.querySelector(".sitenav__link");
    if (sitenavlink !== document.activeElement) {
      sitenavlink.setAttribute("aria-expanded", false);
    }
  });
  // Start timeout to close sitenav dropdown
  if (delay) {
    dropdownclosetimer = window.setTimeout(sitenav__close, 250);
  } else {
    sitenav__close();
  }
} // sitenavitem__over()

function sitenav__close() {
  // when time out ends and nav open is still false, close the sitenav
  if (!navopen) {
    // Set height to 0 and remove classes
    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }
    document.querySelector("body").classList.remove(navopenbodyclass);
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    sitenavdropdown.style.height = 0;
    sitenavdropdown.style.visibility = "hidden";
  }
} // sitenav__close

/*  ==========================================================================
	NAVIGATION - collapse header to smaller version on scroll up
	========================================================================== */

const header = document.querySelector(".siteheader");
let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

function siteHeaderOnScroll() {
  const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScrollTop === 0) {
    // At the very top, remove the collapsed class
    header.classList.remove("siteheader--collapsed");
    header.classList.remove("siteheader--scrolling");
  } else {
    // Scrolling down - remove the collapsed state
    header.classList.add("siteheader--collapsed");
  }

  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Prevent negative values
}

window.addEventListener("scroll", function () {
  siteHeaderOnScroll();
});

siteHeaderOnScroll();

/*  ==========================================================================
	NAVIGATION - Resources back button
	========================================================================== */

function goBack(el) {
  const fallbackUrl = el.getAttribute("data-fallbackurl") || "/";
  if (history.length > 1) {
    history.back();
  } else {
    window.location.href = fallbackUrl;
  }
}

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();

/*  ==========================================================================
	SEARCH - Header Navigation
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".siteheader__search .searchform__input input");
const searchForm = document.querySelector(".siteheader__search .searchform");

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("siteheader__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; //clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();

  const lastFocusedElement = document.activeElement;

  const searchInput = searchNav.querySelector('input:not([type="hidden"]), textarea, [contenteditable="true"]');

  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.classList.remove(navopenbodyclass);
    body.removeEventListener("mouseup", clickedOusideSearch, false);

    // Optional: return focus
    if (lastFocusedElement) lastFocusedElement.focus();
  } else {
    searchNav.classList.add("siteheader__search--open");
    body.classList.add(navopenbodyclass);

    if (searchInput) {
      // Small timeout ensures visibility + avoids CSS transition issues
      setTimeout(() => {
        searchInput.focus();
      }, 0);
    }

    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
};

const searchModalInit = function () {
  if (!searchNav || !searchToggle) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);

  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && searchNav.classList.contains("siteheader__search--open")) {
      searchNav.classList.remove("siteheader__search--open");

      if (accesibilityLastFocusedElement) {
        accesibilityLastFocusedElement.focus();
        accesibilityLastFocusedElement = false;
      }
    }
  });
}; // searchModalInit();

searchModalInit();

/*  ==========================================================================
   filterGetPosts: Calls the ajax function that retrieve the posts that match
   the selected filters
    ========================================================================== */

/*  ==========================================================================
    Total active filter count (global)
    ========================================================================== */
function updateTotalFilterCount() {
  const counterEl = document.querySelector(".filter__total-tagcount");
  if (!counterEl) return;

  const checkedCount = document.querySelectorAll(".filters__fieldset input[type='checkbox']:checked").length;

  counterEl.textContent = checkedCount > 0 ? `(${checkedCount})` : "";
}

const scrollToFilterPin = function () {
  const pin = document.querySelector(".filter");
  if (document.querySelector(".main--topicsearch")) return; // Don't scroll on topic search page

  if (!pin) return;

  const yOffset = -20; // adjust if you have a sticky header
  const y = pin.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({
    top: y,
    behavior: "smooth"
  });
};

const updateFilterInnerState = function () {
  const filterInner = document.querySelector(".filter__inner");
  if (!filterInner) return;

  const hasOpenDropdown = [...document.querySelectorAll(".filterdrop")].some(drop =>
    drop.classList.contains("is-active")
  );

  const hasTags = document.querySelectorAll(".filter__active__tag").length > 0;

  filterInner.classList.toggle("is-active", hasOpenDropdown || hasTags);
};
const updateShowingCount = function (total) {
  const countEl = document.querySelector(".filter__applied .count");
  if (!countEl || typeof total !== "number") return;

  countEl.textContent = total;
};

/*  ==========================================================================
    Filters — dropdown active state (onclick)
    ========================================================================== */
const filterDrops = document.querySelectorAll(".filterdrop:not(.filterdrop--resources)");
const filterDropsWrapper = document.querySelector(".filter__inner");

const filterDropCloseAll = function () {
  filterDrops.forEach(function (drop) {
    drop.classList.remove("is-active");
  });

  updateFilterInnerState();
};

const filterDropInit = function () {
  if (!filterDrops.length) {
    return;
  }

  filterDrops.forEach(function (drop) {
    const label = drop.querySelector(".filter__label");
    if (!label) return;

    label.onclick = function (e) {
      e.preventDefault();

      const isActive = drop.classList.contains("is-active");

      filterDropCloseAll();

      if (!isActive) {
        drop.classList.add("is-active");
      }

      updateFilterInnerState();
    };
  });

  // Close dropdowns on outside click
  document.addEventListener("click", function (e) {
    filterDrops.forEach(function (drop) {
      if (!drop.contains(e.target)) {
        drop.classList.remove("is-active");
      }
    });

    updateFilterInnerState();
  });
};

filterDropInit();

const filters = document.querySelector(".filters");
const filtersToggle = document.querySelector(".filters__dropdownbtn");
const filtersDropdown = document.querySelector(".filters__dropdown");
const filtersForm = document.querySelector(".filters__form");
const selectedOptionCounter = document.querySelector(".filters__activecount");
const searchKeyword = document.querySelector(".filter__input--search input");
const isAutoSubmit = filters?.dataset.filterAutosubmit === "true";

const filterOpen = document.querySelector(".filter__label--open");

if (filterOpen) {
  filterOpen.addEventListener("click", function (e) {
    e.preventDefault();
    // filters.classList.toggle("is-active");
    const isOpen = filters.classList.toggle("is-active");

    document.body.classList.toggle("filter-open", isOpen);
  });
}

const updateFilterActiveState = function () {
  const filterInner = document.querySelector(".filter__inner");
  if (!filterInner) return;

  const tagCount = document.querySelectorAll(".filter__active__tag").length;
  if (tagCount > 0) {
    filterInner.classList.add("is-active");
  } else {
    filterInner.classList.remove("is-active");
  }
};

const renderActiveFilterTags = function () {
  const container = document.querySelector(".filter__active__tags");
  if (!container) return;

  container.innerHTML = "";

  const checkedInputs = document.querySelectorAll(".filters__fieldset input[type='checkbox']:checked");

  checkedInputs.forEach(function (input) {
    if (input.name === "content-type" && input.value === "") return;

    const labelEl = input.closest(".filters__fieldset__field");
    if (!labelEl) return;

    const text = labelEl.querySelector(".filters__fieldset__field__label")?.textContent || input.value;

    const tag = document.createElement("button");
    tag.type = "button";
    tag.className = "filter__active__tag tag";
    tag.innerHTML = `
      <span>${text}</span>
      <span class="filter__active__tag__remove" aria-hidden="true">×</span>
    `;

    // Remove handler
    tag.addEventListener("click", function () {
      input.checked = false;
      labelEl.classList.remove("active");

      const filterData = filterGetFormData();
      filterUpdateURL(filterData);
      filterGetPosts(true);

      updateFilterDropCounts();
      updateAppliedFiltersVisibility();

      renderActiveFilterTags(); // ⬅ rebuild tags first
      updateFilterInnerState(); // ⬅ then recalc active state
      scrollToFilterPin();
    });

    container.appendChild(tag);
  });
};
const clearAllFilters = function () {
  // 1) Uncheck all checked boxes + remove active class on their labels
  document.querySelectorAll(".filters__fieldset input[type='checkbox']:checked").forEach(function (input) {
    input.checked = false;

    const labelEl = input.closest(".filters__fieldset__field");
    if (labelEl) labelEl.classList.remove("active");
  });

  // 1b) Clear search input value, if present
  if (searchKeyword) {
    searchKeyword.value = "";
  }

  // 2) Clear tags UI immediately (no layout changes, just empty)
  const tags = document.querySelector(".filter__active__tags");
  if (tags) tags.innerHTML = "";

  // 3) Close any open filter dropdown panels
  if (typeof filterDropCloseAll === "function") {
    filterDropCloseAll();
  }

  // 4) Trigger your existing submit flow (AJAX + URL + UI refresh)
  if (filtersForm) {
    filtersForm.dispatchEvent(new Event("submit", { bubbles: true }));
  }
};

const updateAppliedFiltersVisibility = function () {
  const applied = document.querySelector(".filter__applied");

  if (!applied) return;

  const checkedCount = document.querySelectorAll(".filters__fieldset input[type='checkbox']:checked").length;

  applied.style.display = checkedCount > 0 ? "flex" : "none";
};

const updateFilterDropCount = function (drop) {
  const fieldset = drop.querySelector(".filters__fieldset");
  const countEl = drop.querySelector(".count");
  if (!fieldset || !countEl) return;

  const checked = fieldset.querySelectorAll("input[type='checkbox']:checked");
  const count = checked.length;

  countEl.textContent = count > 0 ? `(${count})` : "";
};

const updateAllFilterDropCounts = function () {
  document.querySelectorAll(".filterdrop").forEach(updateFilterDropCount);
};

const updateFilterDropCounts = function () {
  const drops = document.querySelectorAll(".filterdrop");

  drops.forEach(function (drop) {
    const fieldset = drop.querySelector(".filters__fieldset");
    const countEl = drop.querySelector(".count");

    if (!fieldset || !countEl) return;

    const checked = fieldset.querySelectorAll("input[type='checkbox']:checked");
    const count = checked.length;

    countEl.textContent = count > 0 ? `(${count})` : "";
  });
};

/*  ==========================================================================
   filterUpdateURL: Updates the url with the selected values
    ========================================================================== */

const filterUpdateURL = function (filterData) {
  const filtersEl = document.querySelector(".filters");
  if (!filtersEl) return;

  const baseUrl = filtersEl.dataset.filterPageUrl || window.location.href;

  const url = new URL(baseUrl);

  // Clear existing filter params
  [...url.searchParams.keys()].forEach(key => {
    if (key.startsWith("filter_") || key === "search" || key === "pagenum") {
      url.searchParams.delete(key);
    }
  });

  Object.entries(filterData).forEach(([key, value]) => {
    // TAXONOMY FILTERS
    if (Array.isArray(value)) {
      const cleaned = value.filter(v => v !== "");

      // Only set param if we actually have values
      if (cleaned.length > 0) {
        url.searchParams.set(`filter_${key}`, cleaned.join(","));
      }
    }

    // SEARCH
    if (key === "search" && typeof value === "string" && value.trim() !== "") {
      url.searchParams.set("search", value.trim());
    }
  });
  if (document.querySelector(".main--topicsearch")) {
    window.location.href = url.toString();
  } else {
    window.history.pushState({}, "", url.toString());
  }
};

/*  ==========================================================================
   filterGetFormData: Gets selected options from the filter columns
    ========================================================================== */
const filterGetFormData = function () {
  let filterData = {};
  let counter = 0;

  // TAXONOMY FILTERS
  filter_settings.filters.forEach(function (el) {
    if (el.filter_type !== "taxonomy") return;

    const checkedOptions = document.querySelectorAll("input[name='" + el.name + "']:checked");

    if (checkedOptions.length > 0) {
      filterData[el.name] = [...checkedOptions].map(x => x.value);
      counter += checkedOptions.length;
    }
  });

  // SEARCH
  if (searchKeyword && searchKeyword.value.trim() !== "") {
    filterData.search = searchKeyword.value.trim();
  } else {
    // searchKeyword = "";
  }

  return filterData;
};

const filterGetPosts = function (updateURL) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let pageData = false;

  if (!filterData) {
    return;
  }

  // Start filtering
  document.querySelector(".posts.loadmore-container").classList.add("filtering");

  // Trigger ajax
  let data = {
    action: "filter",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
    page: php_variables.current_page,
    search: searchKeyword?.value || "",
    filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
    filter_data: filterData
  };

  $.ajax({
    url: php_variables.ajax_url,
    data: data, // form data
    dataType: "json", // this data type allows us to receive objects from the server
    type: "POST",
    success: function (data) {
      // when filter applied:
      // set the current page to 1
      php_variables.current_page = 1;

      // set the new query parameters
      php_variables.posts = data.posts;

      // set the new max page parameter
      php_variables.max_page = data.max_page;

      // hide load more button, if there are not enough posts for the second page
      updateShowingCount(data.found_posts);

      const pagingLoadmore = document.querySelector(".paging__loadmore");
      if (pagingLoadmore) {
        if (data.max_page < 2) {
          pagingLoadmore.style.display = "none";
        } else {
          pagingLoadmore.style.display = "block";
        }
      }

      // insert the posts to the container
      const loadmoreContainer = document.querySelector(".posts.loadmore-container");
      if (loadmoreContainer) {
        loadmoreContainer.innerHTML = data.content;
        // Finish filtering
        loadmoreContainer.classList.remove("filtering");
      }

      //Refreshing animations effects
      setTimeout(function () {
        Waypoint.refreshAll();
        topicsToggleInit();
      }, 500);

      lazyLoadInstance.update();
    },
    error: function (data) {}
  });
};

/*  ==========================================================================
   filterInit: Initialise the filtering functions when there is a filter
   available
    ========================================================================== */
const filterCloseDropdown = function () {
  filters.classList.remove("filters--dropdownopen");
  filtersToggle?.setAttribute("aria-expanded", "false");
  filtersToggle?.focus();
};

const filterInit = function () {
  if (!filters) return;
  const filtersOptions = filters.querySelectorAll(".filters__fieldset__field");
  filtersOptions.forEach(function (option) {
    const input = option.querySelector("input");
    if (!input) return;

    input.addEventListener("change", function () {
      if (this.name === "content-type" && !this.checked) {
        // Revert immediately — one must always be active
        this.checked = true;
        return;
      }
      option.classList.toggle("active", this.checked);

      // Only apply to content-type taxonomy
      if (input.name !== "content-type") return;

      const fieldset = input.closest(".filters__fieldset");
      if (!fieldset) return;

      const allInput = fieldset.querySelector("input[data-content-type-all]");
      const otherInputs = fieldset.querySelectorAll("input[name='content-type']:not([data-content-type-all])");

      // If "All" was checked → clear others
      if (input.hasAttribute("data-content-type-all") && input.checked) {
        otherInputs.forEach(i => {
          i.checked = false;
          i.closest(".filters__fieldset__field")?.classList.remove("active");
        });
      }

      // If a specific type was checked → uncheck All + other types
      if (!input.hasAttribute("data-content-type-all") && input.checked) {
        if (allInput) {
          allInput.checked = false;
          allInput.closest(".filters__fieldset__field")?.classList.remove("active");
        }

        otherInputs.forEach(i => {
          if (i !== input) {
            i.checked = false;
            i.closest(".filters__fieldset__field")?.classList.remove("active");
          }
        });
      }

      // Auto-submit (your new page behaviour)
      if (isAutoSubmit) {
        const filterData = filterGetFormData();
        filterUpdateURL(filterData);
        filterGetPosts(true);

        filterDropCloseAll();
        updateFilterDropCounts();
        updateAppliedFiltersVisibility();
        renderActiveFilterTags();
        updateFilterInnerState();
        updateTotalFilterCount();
        scrollToFilterPin();
      }
    });
  });

  const clearAllBtn = document.querySelector(".filter__clearall");

  if (clearAllBtn) {
    clearAllBtn.addEventListener("click", function (e) {
      e.preventDefault();
      clearAllFilters();
    });
  }

  // Set initial counts per dropdown
  updateAllFilterDropCounts();

  let lastFocusedElement = false;

  // Setting up on esc listener if the drowdown is open to close modal
  // and return focus to toggle
  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Escape key pressed
      filterCloseDropdown(lastFocusedElement);
    }
  });

  document.addEventListener(
    "click",
    function (event) {
      // If user either clicks X button OR clicks outside the modal window, then close modal by calling closeModal()
      if (!event.target.closest(".filters__dropdown") && !event.target.classList.contains("filters__dropdownbtn")) {
        filterCloseDropdown(lastFocusedElement);
      }
    },
    false
  );

  const cancelBtn = filters.querySelector(".actions__cancel");
  if (cancelBtn) {
    cancelBtn.addEventListener("click", function (e) {
      e.preventDefault();

      filterCloseDropdown(lastFocusedElement);
    });
  }

  // Dropdown open & close
  if (filtersToggle) {
    filtersToggle.addEventListener("click", function (e) {
      e.preventDefault();

      filters.classList.toggle("filters--dropdownopen");
      // filtersForm.hidden = false;

      if (filters.classList.contains("filters--dropdownopen")) {
        // Store the last focused element
        lastFocusedElement = document.activeElement;

        // Putting the focus on the first input on the list
        if (filtersOptions && filtersOptions[0]) {
          filtersOptions[0].focus();
        }
      }
      // Setting the aria label for the dropdown
      let aria = filtersToggle.getAttribute("aria-expanded");

      if (aria === "true") {
        aria = "false";
      } else {
        aria = "true";
      }
      filtersToggle.setAttribute("aria-expanded", aria);
    });
  }

  // Filter on submit
  if (filtersForm) {
    const clearButtons = filters.querySelectorAll(".filterdrop button[type='reset']");

    clearButtons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        const drop = btn.closest(".filterdrop");
        if (!drop) return;

        // 1. Uncheck ONLY inputs inside this dropdown
        const inputs = drop.querySelectorAll("input[type='checkbox']");
        inputs.forEach(input => {
          input.checked = false;

          const label = input.closest(".filters__fieldset__field");
          if (label) {
            label.classList.remove("active");
          }
        });

        // 2. Close this dropdown
        drop.classList.remove("is-active");

        // 3. Re-render UI state BEFORE submit
        updateFilterDropCounts();
        renderActiveFilterTags();
        updateAppliedFiltersVisibility();
        updateFilterInnerState();

        // 4. Trigger submit (AJAX + URL update)
        filtersForm.dispatchEvent(new Event("submit", { bubbles: true }));
      });
    });

    filtersForm.addEventListener("submit", function (e) {
      const filtersRoot = filtersForm.closest(".filters");

      // Allow native submit ONLY for resources search filter
      if (filtersRoot?.classList.contains("filter--resources--search")) {
        return;
      }

      // All other filters stay AJAX-only
      e.preventDefault();

      const filterData = filterGetFormData();
      filterUpdateURL(filterData);
      filterGetPosts(true);

      filterDropCloseAll();
      updateFilterDropCounts();
      updateAppliedFiltersVisibility();
      renderActiveFilterTags();
      updateFilterInnerState();

      filterCloseDropdown();
      scrollToFilterPin();
      updateTotalFilterCount();
    });
  }
  document.addEventListener("click", function (e) {
    const clearAllBtn = e.target.closest(".filter__clearall");
    if (!clearAllBtn) return;

    e.preventDefault();
    clearAllFilters();
  });
  renderActiveFilterTags();
  updateAppliedFiltersVisibility();
  updateFilterInnerState();
  updateFilterDropCounts();
  updateTotalFilterCount();
};

filterInit();

/*  ==========================================================================
    Mobile global filter actions
    ========================================================================== */

const mobileActions = document.querySelector("[data-filter-mobile-actions]");
const mobileApplyBtn = document.querySelector(".filter__mobile-apply");
const mobileClearBtn = document.querySelector(".filter__mobile-clear");

const isMobileView = () => window.matchMedia("(max-width: 1200px)").matches;

if (mobileActions) {
  // APPLY ALL (mobile)
  mobileApplyBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    if (!isMobileView()) return;

    const filterData = filterGetFormData();
    filterUpdateURL(filterData);
    filterGetPosts(true);

    filterDropCloseAll();
    updateFilterDropCounts();
    updateAppliedFiltersVisibility();
    renderActiveFilterTags();
    updateFilterInnerState();

    filterCloseDropdown();
    scrollToFilterPin();
    updateTotalFilterCount();
    filters.classList.remove("is-active");
    document.body.classList.remove("filter-open");
  });

  // CLEAR ALL (mobile)
  mobileClearBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    if (!isMobileView()) return;

    clearAllFilters();
    scrollToFilterPin();
    updateTotalFilterCount();
    filters.classList.remove("is-active");
    document.body.classList.remove("filter-open");
  });
}
